import classNames from "classnames";
import "./index.scss";
import CustomModal from "../CustomModal";
import { boolean } from "yup";
import { useState } from "react";
import CustomBadges from "../CustomBadges";

// import downloadIcon from './downloadIcon.png';


type Props = {
  imageUrl: string;
  onClick?: () => void;
  size?: "small" | "medium" | "large" | "x-large";
  hoverTitle?: string | null;
};

const ImageViewer = ({ imageUrl }: Props) => {
  const [zoomInImage, setZoomInImage] = useState<string>("");

  function downloadImage(url: string, filename: string): void {
    fetch(url)
      .then(res => res.blob())
      .then(blob => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }

  return (
    <>
      {imageUrl ? (
        <>
          <section id="imageViewer">
            <div className="imageViewer-container" onClick={() => setZoomInImage(imageUrl)}>
              <img src={imageUrl} alt={imageUrl}/>
            </div>
              <img
                onClick={() => downloadImage(
                imageUrl,
                String(imageUrl.split('/').pop())
                  )
                }
                className={'download-icon'}
                src={'/icons/downloadIcon.png'}
                alt={'downloadIcon.png'}
              />
          </section>
          <CustomModal
            open={zoomInImage !== ""}
            onClose={() => setZoomInImage("")}
            width={"50rem"}
            maxHeight={"85vh"}
          >
            <div className="zoom-in-container">
              <img src={imageUrl} alt={imageUrl} />
            </div>
          </CustomModal>
        </>
      ) : (
        <section id="imageViewer">
          <div className="imageViewer-container">
            <CustomBadges title={"تصویر بارگذاری نشده !"} type="danger" />
          </div>
        </section>
      )}
    </>
  );
};

export default ImageViewer;
